/* eslint-disable */
import ko from 'knockout';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';
export default function (options) {
  this.options = options || ({});
  this.hasError = ko.observable('');
  this.tutorialSectionExplandClass = this.options.hideTutorial ? ko.observable('expanderImage') : ko.observable('expandedImage');
  this.updateTutorialSectionStatus = function () {
    if (this.tutorialSectionExplandClass() === 'expandedImage') {
      this.tutorialSectionExplandClass('expanderImage');
      localStorage.set('uet_upload_tut_hide', true);
    } else {
      this.tutorialSectionExplandClass('expandedImage');
      localStorage.set('uet_upload_tut_hide', false);
    }
  };
}

